<script>
    import { onMount } from 'svelte';
    import { db, breakId, loggedInUsers } from './stores.js';
    import Datepicker from './components/Datepicker.svelte';
    import Cyphers from './Cyphers.svelte';
    import Notifications from './Notifications.svelte';
    import ShowAndTell from './ShowAndTell.svelte';
    import Tutorials from './Tutorials.svelte';
    import Break from './Break.svelte';
    import Sessions from './Sessions.svelte';

    let mode = "dashboard";
    let session_mode;
    let session_mode_input;
    let next_session;
    let next_session_input;
    let upcoming;
    let timer;
    let isLive;

    let session_status="";
    let showAndTellEntries = [];

    let tutorialMode;
    let tutorials;
    let tutorialsFiltered;

    // let loggedInUsers;

    let invitedUsers;

    let bannedUsers;

    let showUsers = false;


    // let showAndTellFiltered;

    $: sATEntriesApproved = showAndTellEntries.filter(entry => entry.status.approved === true);
    $: sATEntriesDenied = showAndTellEntries.filter(entry => entry.status.approved === false && entry.status.data);
    $: sATEntriesPending = showAndTellEntries.filter(entry => entry.status.approved === false && !entry.status.data);
    $: showAndTellFiltered = [];

    onMount(async () => {
        $db.collection("data").doc("status")
            .onSnapshot((doc) => {
                console.log("current data: ", doc.data());
                session_mode = doc.data().session_mode;
                next_session = doc.data().next_session;
                upcoming = doc.data().upcoming;
                isLive = doc.data().live;
                invitedUsers = doc.data().invited;
                timer.restart(next_session);
            });

        // $db.collection("showandtell").where("status.approved", "==", true)
        $db.collection("showandtell")
            .onSnapshot((querySnapshot) => {
                showAndTellEntries = [];
                querySnapshot.forEach((doc) => {
                    // console.log("showandtell",doc.data(), doc.id);
                    // showAndTellEntries.push(doc.data());
                    showAndTellEntries = [...showAndTellEntries, {...doc.data(), uid: doc.id}];
                })
                console.log("showAndTellEntries: ",showAndTellEntries);
            });
        
        $db.collection("tutorials")
            .onSnapshot((querySnapshot) => {
                tutorials = [];
                querySnapshot.forEach((doc) => {
                    // console.log("tutorial",doc.data(), doc.id);
                    tutorials = [...tutorials, {...doc.data(), uid: doc.id}];
                })
                console.log("tutorials: ",tutorials);
            });

        $db.collection("users").where("isLoggedIn", "==", true)
            .onSnapshot((querySnapshot) => {
                let loggedInUsersFromDatabase = [];
                querySnapshot.forEach((doc) => {
                    // if(doc.data().isInvited){
                    //     console.log("loggedInUsers isInvited is there");
                    // } else {
                    //     console.log("loggedInUsers isInvited is NOT there")
                    // }
                    loggedInUsersFromDatabase = [...loggedInUsersFromDatabase, {...doc.data(), uid: doc.id}];
                });
                console.log("loggedInUsersFromDatabase: ", loggedInUsersFromDatabase);
                loggedInUsers.set(loggedInUsersFromDatabase);
            });


        $db.collection("banned").doc("users")
            .onSnapshot((doc) => {
                console.log("current data: ", doc.data());
                bannedUsers = doc.data().ids;
            });




        console.log('sATEntriesApproved: ', sATEntriesApproved);
    });

    function setNextSession(){
        // set the next_session / session_mode in firestore
        console.log(session_mode_input, next_session_input);
        $db.collection("data").doc("status").set({
            session_mode: session_mode_input,
            next_session: next_session_input
        }, {merge: true}).then(() => {
            console.log("Session successfully updated!");
            timer.restart(next_session);
            session_status = "Next session set!"
        }).catch((error) => {
            console.error("Error updating session: ", error);
            session_status = `Error updating session: ${error}`;
        });
    }

    function handleDateTimeChangeEvent(event) {
        console.log("event: ", event);
        next_session_input = event.detail.datetimeMs;
    }

    function toggleLive(){
        // isLive = !isLive;
        $db.collection("data").doc("status").set({
            live: !isLive
        }, {merge: true}).then(() => {
            console.log("Live status successfully updated!")
        }).catch((error) => {
            console.error("Error updating live status: ", error);
        });
    }

    function displayShowAndTell(entries){
        // mode = "";
        // showAndTellFiltered = [];
        // showAndTellFiltered = [...entries];
        const clearEntryEvent = new CustomEvent('clearEntry',{data:"test data"});
        console.log('displayShowAndTell');
        window.dispatchEvent(clearEntryEvent);

        showAndTellFiltered = entries;
        mode = "showandtell";
        console.log("showAndTellFiltered: ",showAndTellFiltered);
    }

    function displayTutorials(status){
        const clearTutorialEvent = new CustomEvent('clearTutorial',{data:"test data"});
        console.log('displayTutorials');
        window.dispatchEvent(clearTutorialEvent);

        mode = "tutorials";
        tutorialMode = status;
        if (status === "add") {
            tutorialsFiltered = null;
        } else {
            tutorialsFiltered = tutorials.filter(tutorial => tutorial.status === status);
        }
        console.log("showAndTellFiltered: ",tutorialsFiltered);
    }

    function inviteUser(uid) {
        // update data > status > invited;
        console.log("inviteUser: ", uid);
        // remove from invitedList and save back to database
		// const updatedInvitedList = [...invitedUsers, uid];
		// console.log("updatedInvitedList: ", updatedInvitedList);
		// $db.collection("data").doc("status").set({
		// 	invited: updatedInvitedList
		// }, {merge: true}).then(() => {
		// 	console.log("Invited list successfully updated!");
		// }).catch((error) => {
		// 	console.error("Error updating invited list: ",error);
		// });

		$db.collection("users").doc(uid).set({
			isInvited: true,
            breakId: $breakId
		}, {merge: true}).then(() => {
			console.log("User successfully invited!");
		}).catch((error) => {
			console.error("Error inviting user: ",error);
		});

    }

    function uninviteUser(uid) {
        console.log("uninviteUser: ", uid);
        // const updatedInvitedList = invitedUsers.filter(invitedId => invitedId !== uid);
		// console.log("updatedInvitedList: ", updatedInvitedList);
		// $db.collection("data").doc("status").set({
		// 	invited: updatedInvitedList
		// }, {merge: true}).then(() => {
		// 	console.log("Invited list successfully updated!");
		// }).catch((error) => {
		// 	console.error("Error updating invited list: ",error);
		// });

		$db.collection("users").doc(uid).set({
			isInvited: false
		}, {merge: true}).then(() => {
			console.log("User successfully uninvited!");
		}).catch((error) => {
			console.error("Error uninviting user: ",error);
		});

    }

    function isInvited(uid) {
        console.log("isInvited: ", uid);
        return invitedUsers.includes(uid);
    }



    function banUser(uid) {
        // update banned > users > ids;
        console.log("banUser: ", uid);
        // const updatedBannedUsers = [...bannedUsers, uid];
        // console.log("updatedBannedUsers: ", updatedBannedUsers);
		// $db.collection("banned").doc("users").set({
		// 	ids: updatedBannedUsers
		// }, {merge: true}).then(() => {
		// 	console.log("Banned list successfully updated!");
		// }).catch((error) => {
		// 	console.error("Error updating banned list: ",error);
		// });

        $db.collection("users").doc(uid).set({
			isBanned: true
		}, {merge: true}).then(() => {
			console.log("User successfully banned!");
		}).catch((error) => {
			console.error("Error banning user: ",error);
		});


    }


    function unbanUser(uid) {
        // update banned > users > ids;
        console.log("banUser: ", uid);
        // const updatedBannedUsers = [...bannedUsers, uid];
        // console.log("updatedBannedUsers: ", updatedBannedUsers);
		// $db.collection("banned").doc("users").set({
		// 	ids: updatedBannedUsers
		// }, {merge: true}).then(() => {
		// 	console.log("Banned list successfully updated!");
		// }).catch((error) => {
		// 	console.error("Error updating banned list: ",error);
		// });

        $db.collection("users").doc(uid).set({
			isBanned: false
		}, {merge: true}).then(() => {
			console.log("User successfully unbanned!");
		}).catch((error) => {
			console.error("Error unbanning user: ",error);
		});


    }



</script>

<section>
    <div id="menu">
        Live? {isLive} <br/>
        <button on:click={toggleLive}>{isLive ? "STOP" : "GO" } LIVE </button> <br/>
        current mode: { session_mode }
        <dwane-timer bind:this={timer} timer-deadline={next_session} countdown-start="3600000" timer-orientation="horizontal"></dwane-timer>
        <Datepicker on:datetimechange={handleDateTimeChangeEvent} />
        <select bind:value={session_mode_input}>
            <option value="work">work</option>
            <option value="break">break</option>
        </select>
        <button on:click={setNextSession}>submit</button>
        <br/>session status: {session_status}
        <h2>Cyphers</h2>
        <ul>
            <li on:click={() => mode = "cyphers"}>view / add / delete</li>
            <li on:click={() => mode = "notifications"}>notifications</li>
        </ul>
        <h2>Sessions</h2>
        <ul>
            <!-- <li on:click={() => mode = "work"}>work</li> -->
            <li on:click={() => mode = "break"}>start break</li>
            <li on:click={() => mode = "sessions"}>view/edit</li>
        </ul>
        <h2>Show and Tell</h2>
        <ul>
            <li on:click={() => displayShowAndTell(sATEntriesApproved)}>approved {sATEntriesApproved.length}</li>
            <li on:click={() => displayShowAndTell(sATEntriesDenied)}>denied {sATEntriesDenied.length}</li>
            <li on:click={() => displayShowAndTell(sATEntriesPending)}>pending {sATEntriesPending.length}</li>
        </ul>
        <h2>Tutorials</h2>
        <ul>
            <li on:click={() => displayTutorials("add")}>add</li>
            <li on:click={() => displayTutorials("pending")}>pending</li>
            <li on:click={() => displayTutorials("active")}>active</li>
            <!-- <li on:click={() => {mode = "tutorials"; tutorialMode = "add"; tutorialsFiltered = null; }}>add</li>
            <li on:click={() => {mode = "tutorials"; tutorialMode = "pending"; tutorialsFiltered = tutorials.filter(tutorial => tutorial.status === "pending"); }}>pending</li>
            <li on:click={() => {mode = "tutorials"; tutorialMode = "active"; tutorialsFiltered = tutorials.filter(tutorial => tutorial.status === "active"); }}>active</li> -->
        </ul>

        <button on:click="{()=> showUsers = !showUsers}">show Users</button>

        
    </div>
    <div id="content">
        {#if mode === "cyphers"}
            <Cyphers upcoming={upcoming.sort((a,b) => a-b)} />
        {:else if mode === "notifications"}
            <Notifications upcoming={upcoming.sort((a,b) => a-b)} />
        <!-- {:else if mode === "work"}
            work -->
        {:else if mode === "break"}
            <Break />
        {:else if mode === "sessions"}
            <Sessions />
        {:else if mode === "showandtell"}
            <ShowAndTell entries={showAndTellFiltered} />
        {:else if mode === "tutorials"}
            <Tutorials mode={tutorialMode} tutorials={tutorialsFiltered}/>
        {:else}
            <div id="select-option">
                select an option
            </div>
        {/if}
    </div>
    {#if showUsers}
        <div id="users-list">
            <button on:click={() => showUsers = false}>close</button><br/>
            {#each $loggedInUsers as user (user.uid)}
                <a href="https://{user.provider}/{user.username}" target="_blank">{user.username}</a>
                {#if user.isInvited}
                    <button on:click={() => uninviteUser(user.uid) } >uninvite</button> &nbsp; &nbsp;
                {:else}
                    <button on:click={() => inviteUser(user.uid) } >invite</button> &nbsp; &nbsp;
                {/if}
                {#if user.isBanned}
                    <button on:click={() => unbanUser(user.uid)}>unban</button>
                {:else}
                    <button on:click={() => banUser(user.uid)}>ban</button>
                {/if}
                <br/>
            {/each}
        </div>
    {/if}

</section>

<style>
    section {
        width: 100vw;
        height: 100vh;
        display: grid;
        place-items: center;
        grid-template-areas: "menu content";
        grid-template-columns: 300px 1fr;
    }

    #menu {
        grid-area: menu;
    }

    #content {
        grid-area: content;
        width: 100%;
        height: 100%;
    }

    ul {
        list-style-type: none;
        margin: 0;
    }

    li {
        cursor: pointer;
        margin-bottom: 10px; 
    }

    h2 {
        margin-bottom: 0
    }

    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }

    button {
        cursor: pointer;
    }

    #users-list {
        height: 90%;
        border: 1px solid black;
        width: 300px;
        position: absolute;
        /* right: -300px; */
        right: 0;
        bottom: 0;
        overflow-y: auto;
        background-color: white;
        /* transition: all 1s ease-in-out; */
    }

    #select-option {
        height: 100%;
        width: 100%;
        display: grid;
        place-content: center;
    }

    /* #users-list.show {
        right: 0;
    } */

</style>